import React, { Component } from 'react'

import get from 'lodash/get'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import withTour from '../../../components/hocs/withTour'
import BlankCard from '../../../components/ui/cards/BlankCard'
import InterestSelectorCard from '../../../components/ui/InterestSelector/InterestSelectorCard'
import PlayButton from '../../../components/ui/playButton/PlayButton'
import PageTitle from '../../../components/ui/typography/PageTitle'
import { currentUserSuccess } from '../../../store/shared/currentUserDuck'
import selectors from '../../../store/shared/selectors'
import * as taskTypesDuck from '../../../store/shared/taskTypesDuck'
import animations from '../../../utils/animations'
import constants from '../../../utils/constants/application'
import intercom from '../../../utils/intercom/intercomUtils'
import notificationsUtils from '../../../utils/notifications/notificationsUtils'
import { getRootFromInsToken } from '../../../utils/string'
import { getInsTokenModules } from '../../unauthenticated/Onboarding/insTokenDuck'
import { performRetrieveUserProfile } from '../UserProfile/userProfileDuck'

import FeedItemModalDisplay from './components/FeedItemModalDisplay'
import FeedSearchForm from './components/FeedSearchForm'
import FeedWrapper from './components/FeedWrapper'
import TasksWrapper from './components/Tasks/TasksWrapper'
import * as dashboardTasksDuck from './dashboardTasksDuck'
import * as feedDuck from './feedDuck'

class AuthenticatedDashboardIndex extends Component {
  static propTypes = {
    currentUser: PropTypes.any,
    currentUserSuccess: PropTypes.func.isRequired,
    dashboardTasks: PropTypes.array.isRequired,
    feedsData: PropTypes.array.isRequired,
    feedsError: PropTypes.string,
    formValues: PropTypes.any.isRequired,
    getFeedsData: PropTypes.func.isRequired,
    isMobile: PropTypes.bool,
    isNoFeeds: PropTypes.bool.isRequired,
    isNoLoadMoreData: PropTypes.bool.isRequired,
    isRequestingFeeds: PropTypes.bool,
    loadingFeeds: PropTypes.bool.isRequired,
    page: PropTypes.number.isRequired,
    performRetrieveDashboardTasks: PropTypes.func.isRequired,
    performRetrieveUserProfile: PropTypes.func.isRequired,
    performSaveFeedItem: PropTypes.func,
    taskTypes: PropTypes.object.isRequired,
    userId: PropTypes.string,
  }

  constructor(props) {
    super(props)

    this.state = {
      showInterestSelector: false,
    }

    this.searchForFeedResults = (page = 1) => {
      const userProfile = this.props.currentUser
      const insToken = getRootFromInsToken(get(userProfile, 'insToken', ''))
      const interests = get(userProfile, 'interests') ? get(userProfile, 'interests') : []
      let searchTerm = this.props.formValues.searchTerm
      let onlyInterestsSearch = false

      if (!searchTerm) {
        searchTerm = interests
        onlyInterestsSearch = true
      }

      this.props.getFeedsData({
        page,
        searchTerm,
        onlyInterestsSearch,
        insToken,
      })
    }

    this.onLoadMore = page => {
      this.searchForFeedResults(page)
    }

    this.saveFeedItem = params =>
      this.props
        .performSaveFeedItem(params)
        .then(() => notificationsUtils.showSuccessNotification('Post Saved Successfully!'))
        .catch(() => {})

    this.retrieveMyTasks = () => this.props.performRetrieveDashboardTasks()

    this.handleInterestSelectionDone = () => this.setState({ showInterestSelector: false })
  }

  componentWillMount() {
    this.props.performRetrieveUserProfile().then(this.props.currentUserSuccess)
    this.retrieveMyTasks()

    if (this.props.currentUser.interests.length < 1 && !this.state.showInterestSelector)
      this.setState({ showInterestSelector: true })
  }

  componentDidMount() {
    this.searchHistoryPanelAnimation = animations.searchHistoryPanelAnimation('#searchHistoryPanel')
    intercom.intercomUpdate({
      user_id: this.props.userId,
    })
    this.searchForFeedResults()
  }

  render() {
    const { showInterestSelector } = this.state
    const {
      dashboardTasks,
      feedsData,
      isNoFeeds,
      isNoLoadMoreData,
      page,
      feedsError,
      taskTypes,
      loadingFeeds,
      openModal,
      getFeedsData,
    } = this.props

    return (
      <div>
        <div id="hiddenVideoDisplay" style={{ display: 'none' }} />
        <div className="main-page">
          <PageTitle content="Career Feeds" tourName="dashboard" />
          <div>
            <div className="row">
              <div className={dashboardTasks.length ? 'col-md-8' : 'col-lg-12'}>
                {showInterestSelector ? (
                  <BlankCard>
                    <InterestSelectorCard
                      handleInterestSelectionDone={() => this.handleInterestSelectionDone()}
                      getFeedsData={getFeedsData}
                    />
                  </BlankCard>
                ) : (
                  <BlankCard notCard id="feedWrapper" delay={0.8}>
                    <div>
                      <div
                        className="row"
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          margin: '0 0 10px 0',
                        }}
                      >
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <h5
                            style={{
                              color: '#787974',
                              marginBottom: 0,
                              marginTop: 10,
                            }}
                          >
                            Hand-picked content, just for you
                          </h5>
                          <PlayButton
                            handleClick={() => openModal(constants.tutorialsFeedItems.homePage)}
                          />
                        </div>
                        <div>
                          <button
                            className="btn btn-link pr-0"
                            id="updateInterests"
                            onClick={() => {
                              this.setState({ showInterestSelector: true })
                            }}
                          >
                            Update Interests
                          </button>
                        </div>
                      </div>
                      <FeedSearchForm onSubmit={this.searchForFeedResults} />
                      <FeedWrapper
                        isLoading={loadingFeeds}
                        isNoData={isNoFeeds}
                        isNoLoadMoreData={isNoLoadMoreData}
                        page={page}
                        onLoadMore={this.onLoadMore}
                        results={feedsData}
                        searchError={feedsError}
                      />
                    </div>
                  </BlankCard>
                )}
              </div>
              {!!dashboardTasks.length && (
                <div className="col">
                  <BlankCard delay={1.2} notCard>
                    <div>
                      <h6 style={{ marginBottom: 5 }}>My Tasks</h6>
                      <TasksWrapper tasks={dashboardTasks} taskTypes={taskTypes} />
                    </div>
                  </BlankCard>
                </div>
              )}
            </div>
          </div>
        </div>
        <FeedItemModalDisplay />
      </div>
    )
  }
}

const makeMapStateToProps = () => {
  const getFormValues = selectors.makeGetFormValues()
  return state => ({
    currentUser: selectors.getCurrentUser(state),
    dashboardTasks: dashboardTasksDuck.getDashboardTasks(state),
    formValues: getFormValues(state.form.feedSearchForm),
    insTokenModules: getInsTokenModules(state),
    isMobile: selectors.isLessThanMedium(state),
    // isNoLoadMoreData: feedDuck.getIsNoLoadMoreData(state),
    // page: state.feed.page,
    searchFilter: state.searchHistory.searchFilter,
    taskTypes: taskTypesDuck.getTasksTypesGroupedByTask(state),
    userId: selectors.getUserId(state),
  })
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      currentUserSuccess,
      performRetrieveDashboardTasks: dashboardTasksDuck.performRetrieveDashboardTasks,
      performRetrieveUserProfile,
      openModal: feedDuck.openModal,
    },
    dispatch,
  )

// Tour Steps
const tourSteps = [
  {
    selector: '#feedWrapper',
    content: "We'll recommend feeds based on the interests you select",
  },
  {
    selector: '#updateInterests',
    content: 'Update your interests here to tailor your content feed',
  },
  {
    selector: '#renderSearchBox',
    content: 'And you can search for your favorite feed topics right here',
  },
  {
    selector: '#left-drawer-nav-link-Personality',
    content: 'We recommend starting with a personality quiz!',
  },
]

export default connect(
  makeMapStateToProps,
  mapDispatchToProps,
)(withTour('dashboard', tourSteps)(AuthenticatedDashboardIndex))



// WEBPACK FOOTER //
// ./src/routes/authenticated/Dashboard/AuthenticatedDashboardIndex.js